import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { QuestionsPeopleHelpedLoadAction } from '../../domains/questionsPeopleHelped/actions.types';

import { QuestionsPeopleHelpedLifecycle } from './types';

const initialState: QuestionsPeopleHelpedLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<QuestionsPeopleHelpedLifecycle, QuestionsPeopleHelpedLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'QUESTIONS_PEOPLE_HELPED.LOAD_PENDING':
      return setPending();
    case 'QUESTIONS_PEOPLE_HELPED.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.questionsPeopleHelped);
    case 'QUESTIONS_PEOPLE_HELPED.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
